import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useWizard } from 'ui-components/components/wizard/context';

import style from '../style.module.less';

export const WizardHeader = ({ stepId }) => {
  const { activeStep, getStepLabel } = useWizard();

  const isActiveStep = stepId === activeStep.stepId;
  const wizardClasses = classnames(style['wizard-step-header'], {
    [style.selected]: isActiveStep,
  });

  const chevronClasses = classnames(style.chevron, {
    [style.selected]: isActiveStep,
  });

  return (
    <>
      <div className={wizardClasses}>{getStepLabel(stepId)}</div>
      <div className={chevronClasses} />
    </>
  );
};

WizardHeader.propTypes = {
  stepId: PropTypes.string.isRequired,
};
